/**
 * Undo / redo as whole-document snapshots, capped at 100 (the exp editor's
 * model — spec 2026-08-22-02 §4). Serialized strings rather than structural
 * diffs: a floorplan document is small, and a snapshot can never drift out of
 * sync with the live object graph.
 */
export const HISTORY_CAP = 100

export class History {
    private undoStack: string[] = []
    private redoStack: string[] = []

    private readonly cap: number

    constructor(cap: number = HISTORY_CAP) {
        this.cap = cap
    }

    get canUndo(): boolean {
        return this.undoStack.length > 0
    }

    get canRedo(): boolean {
        return this.redoStack.length > 0
    }

    get depth(): number {
        return this.undoStack.length
    }

    /** Records the state *before* a mutation and drops the redo branch. */
    push(snapshot: string): void {
        this.undoStack.push(snapshot)
        if (this.undoStack.length > this.cap) this.undoStack.shift()
        this.redoStack.length = 0
    }

    /** Returns the state to restore, pushing `current` onto the redo stack. */
    undo(current: string): string | null {
        const prev = this.undoStack.pop()
        if (prev === undefined) return null
        this.redoStack.push(current)
        return prev
    }

    redo(current: string): string | null {
        const next = this.redoStack.pop()
        if (next === undefined) return null
        this.undoStack.push(current)
        return next
    }

    reset(): void {
        this.undoStack.length = 0
        this.redoStack.length = 0
    }
}
